<div class="breadcrumbs">
  <ng-container *ngFor="let breadcrumb of breadcrumbs; let i = index">
    <mat-icon *ngIf="i !== 0" class="separator">chevron_right</mat-icon>
    <a class="link" [routerLink]="breadcrumb.route">
      {{ breadcrumb.label }}
    </a>
  </ng-container>
</div>
